import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import { useForm } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import CheckboxInput from '../../../../../../components/form/CheckboxInput'
import ColorPicker from '../../../../../../packages/kiti/components/form/ColorPicker'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'

const EditWidgetForm = () => {
  const { t } = useTranslation('common')
  const form = useForm()

  return (
    <>
      <Col width="100%">
        <FormItem label={t('widgets.color')} path={['data', 'color']} Input={ColorPicker} />
      </Col>

      <Col width="100%">
        <FormItem label={t('widgets.ignorePeriod')} path={['data', 'ignoreDate']} Input={CheckboxInput} ignoreLabel />
      </Col>
    </>
  )
}

export default EditWidgetForm
